/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 税务申报模块接口</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月23日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//企业税申报台账
	declare: {
		list(params = {}) {
			return Ajax.get('/tax-declare', params)
		},
		save(p) {
			return Ajax.post('/tax-declare', p)
		},
		update(p) {
			return Ajax.put('/tax-declare', p)
		},
		delete(id) {
			return Ajax.delete(`/tax-declare/${id}`)
		},
		//申报统计（总税种/已申报/已缴款/应补税额）
		summary(params = {}) {
			return Ajax.get('/tax-declare/summary', params)
		}
	},
	//电子税局账号（服务端持久化）
	account: {
		get() {
			return Ajax.get('/tax-account')
		},
		save(p) {
			return Ajax.post('/tax-account', p)
		}
	},
	//税局直连统一入口
	cloud: {
		status() {
			return Ajax.get('/tax-cloud/status')
		},
		rapidDeclare(ids) {
			return Ajax.post('/tax-cloud/rapid-declare', {ids})
		}
	}
};
